module.exports = __webpack_public_path__ + "static/media/education-object-1-3-0.82e3ac86.png";